import React, { useEffect } from "react";
import { DetailDrawer } from "./DetailDrawer";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { useAppModel } from "../appModel";

export function BaseApp() {
    const {
        loadData,
    } = useAppModel()

    useEffect(() => {
        loadData({ pageNum: 1 }).then()
    }, [])

    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
        </>
    );
}

